import React from 'react';
import styles from './LegalPage.module.css';

const appName = process.env.REACT_APP_NAME;

function LegalPage() {
  return (
    <div className={styles['legal-page']}>
      <div className={styles['legal-header']}>
        <h1>Legal & Compliance</h1>
        <p>Last Updated: March 2026</p>
      </div>

      <div className={styles['legal-content']}>
        <section className={styles['legal-section']}>
          <h2>Terms & Conditions</h2>
          <p>
            Welcome to {appName}. By accessing or using our platform, you agree to be bound by these Terms and Conditions. 
            Please read them carefully before using our services.
          </p>
          <p>
            1. <strong>Eligibility:</strong> You must be at least 18 years old and have the legal capacity to enter into a binding agreement to use our platform.
          </p>
          <p>
            2. <strong>Account Responsibility:</strong> You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
          </p>
          <p>
            3. <strong>Trading Risks:</strong> Trading in financial markets involves substantial risk of loss. You acknowledge that all trades are made at your own risk and discretion.
          </p>
          <p>
            4. <strong>Compliance:</strong> You agree to comply with all applicable laws, regulations, and guidelines while using our platform.
          </p>
          <p>
            5. <strong>Service Availability:</strong> We strive to maintain continuous service but do not guarantee uninterrupted access to the platform, especially during maintenance or market volatility.
          </p>
        </section>

        <section className={styles['legal-section']}>
          <h2>Privacy Policy</h2>
          <p>
            At {appName}, we are committed to protecting your privacy. This policy explains how we collect, use, and safeguard your personal information.
          </p>
          <p>
            1. <strong>Information Collection:</strong> We collect personal information necessary for KYC compliance, including your name, contact details, PAN, and bank information.
          </p>
          <p>
            2. <strong>Data Usage:</strong> Your data is used to provide trading services, process transactions, and comply with regulatory requirements.
          </p>
          <p>
            3. <strong>Data Security:</strong> We implement robust security measures to protect your data from unauthorized access, disclosure, or alteration.
          </p>
          <p>
            4. <strong>Third-Party Sharing:</strong> We do not sell your personal data. Information is shared with exchanges, depositories, and regulators as required by law.
          </p>
          <p>
            5. <strong>Cookies:</strong> We use cookies to enhance your experience and analyze platform performance.
          </p>
        </section>

        <section className={styles['legal-section']}>
          <h2>Disclosures</h2>
          <p>
            Investment in the securities market is subject to market risks. 
            Read all the related documents carefully before investing.
          </p>
        </section>
      </div>

      <div className={styles['legal-footer']}>
        <p>© 2026 {appName} Financial Services. All rights reserved.</p>
      </div>
    </div>
  );
}

export default LegalPage;
